import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Box, IconButton, styled, Toolbar } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Fragment, useCallback, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AuthService } from '~/services/service.auth';
import { useService } from '~/services/service.base';
import { UIService } from '~/services/service.ui';
import { Row } from '~/views/atoms/boxes';
import { Icons } from '../../atoms/icons';
import { BurgerMenu } from '~/views/organisms/burger-menu/burger-menu';
import { ROUTES } from '~/routes/routes';
import { LogoIcon } from '~/views/atoms/svg-icons/logo-icon';
import { ServiceIframe } from '~/services/service.iframe';
const Main = styled('main')({ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' });
const sxToolbar = {
    height: UIService.TOOLBAR_HEIGHT,
    '&.MuiToolbar-root': { paddingRight: '8px', paddingLeft: '4px' },
};
export const AppWrapper = observer(() => {
    const { drawerSvc: drawer } = useService(UIService);
    const auth = useService(AuthService);
    const nav = useNavigate();
    const { pathname } = useLocation();
    const iframeService = useService(ServiceIframe);
    const handleLogoClick = useCallback(() => {
        location.href = auth.serviceConfig.mainPageRedirectUrl;
    }, [auth.serviceConfig.mainPageRedirectUrl]);
    const isLoginPage = useMemo(() => pathname === ROUTES.LOGIN.path, [pathname]);
    const handleAccountClick = useCallback(() => {
        nav(ROUTES.LOGIN.path);
    }, [nav]);
    const StyledLogo = styled(LogoIcon)({ '&.MuiSvgIcon-root': { minWidth: '159px', height: '70%' } });
    return (_jsxs(Fragment, { children: [iframeService.inIframe ? null : (_jsx(AppBar, { position: "fixed", color: "default", elevation: 10, children: _jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(IconButton, { onClick: drawer.handleToggle, children: drawer.open ? _jsx(Icons.Close, {}) : _jsx(Icons.Menu, {}) }), _jsx(Row, { flex: 1, justifyContent: "center", children: _jsx(StyledLogo, { onClick: handleLogoClick }) }), _jsx(Box, { width: 40, children: !auth.isLogged && !isLoginPage ? (_jsx(IconButton, { onClick: handleAccountClick, children: _jsx(Icons.Account, {}) })) : null })] }) })), !iframeService.inIframe && _jsx(BurgerMenu, {}), !iframeService.inIframe && _jsx(Row, { minHeight: UIService.TOOLBAR_HEIGHT }), _jsx(Main, { children: _jsx(Outlet, {}) })] }));
});
